import React, { useState } from "react";
import { motion } from "framer-motion";
import { ChevronUp, ChevronDown, Mail, Phone } from "lucide-react";
import { SocialIcon } from "react-social-icons";

const _2dLink = "https://2d.o7ean.de";

const footerSections = [
  {
    heading: "Über O7EAN Gmbh",
    links: [
      {
        text: "Angaben zum Unternehmen",
        href: _2dLink + "/angaben",
      },
      {
        text: "Das Intelligente Unternehmen",
        href: _2dLink + "/intelligente-unternehmen",
      },
    ],
  },
  {
    heading: "Informationen zur Website",
    links: [
      {
        text: "Impressum",
        href: _2dLink + "/impressum",
      },
      {
        text: "Datenschutz",
        href: _2dLink + "/datenschutz",
      },
      {
        text: "Copyright",
        href: _2dLink + "/copyright",
      },
      {
        text: "Cookie Einstellungen",
        href: "#",
      },
      {
        text: "Nutzungsbedingungen",
        href: _2dLink + "/terms-and-conditions",
      },
      {
        text: "AGB",
        href: _2dLink + "/agb",
      },
    ],
  },
];

const previewLinks = [
  { text: "Impressum", href: _2dLink + "/impressum" },
  { text: "Datenschutz", href: _2dLink + "/datenschutz" },
];

export default function CollapsibleFooter() {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <motion.footer
      initial={false}
      animate={isExpanded ? "expanded" : "collapsed"}
      className="absolute bottom-0 left-0 right-0 bg-gray-900 text-gray-300 shadow-lg"
      onDoubleClick={() => setIsExpanded(true)}>
      <div className="container mx-auto px-4 max-h-[60vh] overflow-y-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between py-2">
          <div className="hidden md:flex items-center">
            <img src="/images/o7ean-logo.png" width={32} height={32} alt="O7EAN logo" className="mr-2 invert" />
            <span className="text-lg font-semibold text-gray-100">O7EAN GmbH</span>
          </div>
          <div className="w-full sm:flex-1 flex items-center sm:flex-row sm:items-center sm:justify-end">
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="text-gray-400 hover:text-gray-200 bg-transparent border-none cursor-pointer flex items-center whitespace-nowrap sm:mr-4">
              {isExpanded ? (
                <>
                  <span className="">Einklappen</span>
                  <ChevronDown size={20} />
                </>
              ) : (
                <>
                  <span className="">Mehr anzeigen</span>
                  <ChevronUp size={20} />
                </>
              )}
            </button>
            <div className="flex items-center space-x-4 overflow-x-auto">
              {!isExpanded && (
                <>
                  {previewLinks.map((link, index) => (
                    <a
                      key={index}
                      href={link.href}
                      className="text-sm text-gray-400 hover:text-gray-200 transition-colors whitespace-nowrap">
                      {link.text}
                    </a>
                  ))}
                  <p onClick={() => setIsExpanded(true)} className="cursor-pointer">
                    ...
                  </p>
                </>
              )}
            </div>
          </div>
        </div>

        <motion.div
          variants={{
            expanded: { height: "auto", opacity: 1 },
            collapsed: { height: 0, opacity: 0 },
          }}
          transition={{ duration: 0.3 }}
          className="overflow-hidden">
          <div className="py-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
            {footerSections.map((section, index) => (
              <div key={index}>
                <h3 className="text-lg font-semibold mb-4">{section.heading}</h3>
                <ul className="space-y-2">
                  {section.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      <a href={link.href} className="hover:text-gray-100 transition-colors">
                        {link.text}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            <div>
              <h3 className="text-lg font-semibold mb-4">Kontakt</h3>
              <ul className="space-y-2">
                <li className="flex items-center">
                  <Phone size={16} className="mr-2" />
                  <span>0151 / 15178689</span>
                </li>
              </ul>
              <p className="mt-4 text-sm">Geschäftszeiten: Montag-Freitag 08:00-16:00</p>
            </div>
          </div>

          <div className="border-t border-gray-700 py-4 flex flex-col sm:flex-row justify-between items-center">
            <p className="text-sm mb-4 sm:mb-0">&copy; {new Date().getFullYear()} O7EAN GmbH. Alle Rechte vorbehalten.</p>
            <SocialMediaLinks />
          </div>
        </motion.div>
      </div>
    </motion.footer>
  );
}

function SocialMediaLinks() {
  return (
    <div
      style={{
        display: "flex",
        rowGap: "10px",
        columnGap: "10px",
        flexWrap: "wrap",
        justifyContent: "center",
      }}>
      <SocialIcon url="https://www.facebook.com/profile.php?id=100083551670278" fgColor="#D1D5DB" bgColor="none" />
      <SocialIcon url="https://www.linkedin.com/company/o7ean/" fgColor="#D1D5DB" bgColor="none" />
      <SocialIcon url="https://www.instagram.com/o7ean.de/" fgColor="#D1D5DB" bgColor="none" />
      <SocialIcon url="https://www.x.com/o7ean_gmbh" fgColor="#D1D5DB" bgColor="none" />
    </div>
  );
}
